export default __webpack_public_path__ + "static/media/download-app.05722429.png";